import React from 'react';
import Datas from '../../data/blog/grid.json';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import CommentForm from './components/CommentForm';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/blogDetails.js';

function BlogDetails() {
    const { id } = useParams();

    const blog = Datas.find((item) => String(item.id) === String(id));

    if (!blog) {
        return (
            <Styles>
                <div className="main-wrapper blog-details-page">
                    <HeaderTwo />
                    <BreadcrumbBox title="Blog Not Found" />
                    <section className="blog-details-area">
                        <Container>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <div className="blog-details-box text-center">
                                        <div className="heading">
                                            <h4>Blog not found</h4>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <FooterTwo />
                </div>
            </Styles>
        );
    }

    return (
        <Styles>
            <div className="main-wrapper blog-details-page">
                <HeaderTwo />

                <BreadcrumbBox title={blog.postTitle} />

                <section className="blog-details-area">
                    <Container>
                        <Row>
                            <Col lg="12" md="12" sm="12">
                                <div className="blog-details-box">

                                    <Row className="align-items-start">
                                        <Col lg="6" md="12" sm="12">
                                            <div className="blog-details-banner">
                                                <img
                                                    src={`/assets/images/${blog.postImg}`}
                                                    alt={blog.postTitle}
                                                    className="img-fluid"
                                                />
                                            </div>
                                            <div className="blog-tag_share  justify-content-between flex-wrap">
                                                <div className="blog-tag">
                                                    <ul className="tags list-unstyled list-inline">
                                                        <li className="list-inline-item">Tags:</li>
                                                        {blog.postTags.map((tag, index) => (
                                                            <li className="list-inline-item" key={index}>
                                                                <Link to="/">{tag}</Link>
                                                                {index !== blog.postTags.length - 1 ? ',' : ''}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>

                                                <div className="blog-share mt-5">
                                                    <ul className="social list-unstyled list-inline">
                                                        <li className="list-inline-item">Share:</li>
                                                        <li className="list-inline-item"><a href="/"><i className="fab fa-facebook-f"></i></a></li>
                                                        <li className="list-inline-item"><a href="/"><i className="fab fa-twitter"></i></a></li>
                                                        <li className="list-inline-item"><a href="/"><i className="fab fa-linkedin-in"></i></a></li>
                                                        <li className="list-inline-item"><a href="/"><i className="fab fa-youtube"></i></a></li>
                                                        <li className="list-inline-item"><a href="/"><i className="fab fa-dribbble"></i></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col lg="6" md="12" sm="12">
                                            <div className="heading">
                                                <h4>{blog.postTitle}</h4>
                                            </div>

                                            <div className="blog-auth_date d-flex flex-wrap">
                                                <div className="author-img d-flex">
                                                    <Link to={blog.authorLink}>
                                                        <img
                                                            src={`/assets/images/${blog.authorImg}`}
                                                            alt={blog.authorName}
                                                        />
                                                    </Link>
                                                    <p>
                                                        <Link to={blog.authorLink}>{blog.authorName}</Link>
                                                    </p>
                                                </div>

                                                <div className="post-date">
                                                    <p>
                                                        <i className="las la-calendar"></i> {blog.postDate}
                                                    </p>
                                                </div>

                                                <div className="post-category">
                                                    <p>
                                                        <Link to="/">
                                                            <i className="las la-bookmark"></i> {blog.postCategory}
                                                        </Link>
                                                    </p>
                                                </div>

                                                <div className="post-comment">
                                                    <p>
                                                        <Link to="/">
                                                            <i className="las la-comment"></i> ({blog.postComments})
                                                        </Link>
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="blog-details-desc">
                                                <p>
                                                    {blog.postDetails}
                                                    <br />
                                                    Students benefit greatly when institutions provide regular exposure to
                                                    knowledge-based and skill-based activities that help in overall
                                                    development and confidence building.
                                                </p>

                                                <span>
                                                    <i className="las la-quote-right"></i>
                                                    {blog.postQuote}
                                                </span>

                                                <ul className="list-unstyled">
                                                    {blog.postPoints.map((point, index) => (
                                                        <li key={index}>
                                                            <i className="fa fa-check"></i> {point}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                        </Col>
                                    </Row>


                                    <Row>
                                        <Col lg="7" md="12" sm="12">
                                            <div className="blog-comments">
                                                <h5>Comments ({blog.postComments})</h5>

                                                <div className="comment-box d-flex">
                                                    <div className="comment-image">
                                                        <img src={`/assets/images/testimonial-1.png`} alt="" />
                                                    </div>
                                                    <div className="comment-content">
                                                        <div className="content-title d-flex justify-content-between">
                                                            <div className="comment-writer">
                                                                <h6>Rahul Sharma</h6>
                                                                <p>Apr 26, 2026 | 10:30am</p>
                                                            </div>
                                                            <div className="reply-btn">
                                                                <button type="button">
                                                                    <i className="las la-reply-all"></i> Reply
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="comment-desc">
                                                            <p>This is a very informative blog. It clearly explains the importance of student activities and their role in overall development.</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="comment-box d-flex">
                                                    <div className="comment-image">
                                                        <img src={`/assets/images/testimonial-2.png`} alt="" />
                                                    </div>
                                                    <div className="comment-content">
                                                        <div className="content-title d-flex justify-content-between">
                                                            <div className="comment-writer">
                                                                <h6>Priya Verma</h6>
                                                                <p>Apr 27, 2026 | 01:15pm</p>
                                                            </div>
                                                            <div className="reply-btn">
                                                                <button type="button">
                                                                    <i className="las la-reply-all"></i> Reply
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="comment-desc">
                                                            <p>I liked the way the topic is explained with practical value for students. This kind of content is useful and engaging.</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="comment-box d-flex">
                                                    <div className="comment-image">
                                                        <img src={`/assets/images/testimonial-3.png`} alt="" />
                                                    </div>
                                                    <div className="comment-content">
                                                        <div className="content-title d-flex justify-content-between">
                                                            <div className="comment-writer">
                                                                <h6>Aman Singh</h6>
                                                                <p>Apr 28, 2026 | 04:45pm</p>
                                                            </div>
                                                            <div className="reply-btn">
                                                                <button type="button">
                                                                    <i className="las la-reply-all"></i> Reply
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="comment-desc">
                                                            <p>Very well written and easy to understand. It highlights how college activities contribute to skill building and future success.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col lg="5" md="12" sm="12">
                                            <CommentForm />
                                        </Col>
                                    </Row>

                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    );
}

export default BlogDetails;